import {useState, useRef} from 'react';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';

export const useDropdown = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownAreaRef = useRef<HTMLDivElement>(null);
  useOutsideClick(dropdownAreaRef, () => setIsDropdownOpen(false));

  const openDropdown = () => {
    setIsDropdownOpen(true);
  };
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return {isDropdownOpen, openDropdown, closeDropdown, dropdownAreaRef};
};
